import { render, staticRenderFns } from "./detailedReportBody.vue?vue&type=template&id=47ce7f02&scoped=true"
import script from "./detailedReportBody.vue?vue&type=script&lang=js"
export * from "./detailedReportBody.vue?vue&type=script&lang=js"
import style0 from "./detailedReportBody.vue?vue&type=style&index=0&id=47ce7f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce7f02",
  null
  
)

export default component.exports